import { useMemo } from 'react';
import {
	calculateProportionalSize,
	COLLECTIONS,
	findNearestLargerSize,
	getCollection,
} from '~/assets/collections';
import { StyledImage, StyledMaskImage } from './CurrencyIcon.styled';

const CurrencyIcon = ({
	icon,
	size,
	color,
	asMask = false,
	...props
}: {
	icon: string | null;
	size: keyof (typeof COLLECTIONS)['currency']['sizes'] | number;
	color?: string;
	asMask?: boolean;
} & React.HTMLAttributes<HTMLDivElement>) => {
	const collectionData = getCollection('currency');
	const nearestSize =
		typeof size === 'number' && findNearestLargerSize('currency', size);
	const selectedSize = nearestSize
		? collectionData.sizes[nearestSize as keyof typeof collectionData.sizes]
		: collectionData.sizes[size as keyof typeof collectionData.sizes];

	const displaySize = useMemo(
		() =>
			nearestSize
				? calculateProportionalSize(
						'currency',
						nearestSize as keyof typeof collectionData.sizes,
						size,
				  )
				: selectedSize,
		[nearestSize, selectedSize],
	);

	if (!icon) {
		return (
			<div {...props} style={{ width: displaySize.w, height: displaySize.h }} />
		);
	}

	if (color || asMask) {
		return (
			<StyledMaskImage
				$icon={icon}
				$size={displaySize.w}
				$color={color}
				className="currency-icon"
				{...props}
			/>
		);
	}

	return (
		<StyledImage
			width={displaySize.w}
			height={displaySize.h}
			src={icon || ''}
			className="currency-icon"
			{...props}
		/>
	);
};

export { CurrencyIcon };
